import React from "react";
import { motion } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";

const Stats = () => {
  const { currentTheme } = useTheme();
  const stats = [
    {
      number: "45+",
      label: "Original Songs Created",
      icon: "🎵",
      url: "https://www.youtube.com/@MukeshRathore"
    },
    {
      number: "15000+",
      label: "Youtube Subscribers Trained for free",
      icon: "🎓",
      url: "https://www.youtube.com/@RagaSpectrum"
    },
    {
      number: "90 Days",
      label: "Average Completion",
      icon: "⏱️",
      url: "https://indiemusiccreators.com/"
    },
    {
      number: "5.0★",
      label: "Student Rating",
      icon: "⭐",
      url: "https://indiemusiccreators.com/"
    }
  ];

  return (
    <section className={`py-20 px-6 bg-gradient-to-r ${currentTheme.colors.secondary} text-white`}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Real Impact, Real Results
          </h2>
          <p className="text-xl opacity-90">
            Be part of a community helping aspiring musicians turn passion into reality
          </p>
          <p className="text-lg opacity-80 mt-4">
            👇 Click any stats below to learn more
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.1, rotate: 5 }}
              onClick={() => window.open(stat.url, '_blank')}
              className="text-center bg-white/10 backdrop-blur-sm p-8 rounded-xl hover:bg-white/20 transition-all cursor-pointer"
            >
              <div className="text-5xl mb-4">{stat.icon}</div>
              <div className="text-4xl font-bold mb-2">
                {stat.number}
              </div>
              <div className="text-lg opacity-90">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-2xl font-semibold mb-6">
            ❤️ Thousands of positive engagements from music learners<br />
            ✔ Comments, likes, and sincere appreciation on tutorials
          </p>
          <button 
          onClick={() => window.open('/zoom', '_blank')}
          className="bg-white text-purple-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg text-lg transition-all transform hover:scale-105">
            Start Your Music Journey
          </button>
        </div>
      </div>
    </section>
  );
};

export default Stats;
